import React from 'react';
import { FullPageLoading } from '../../../../CommonComponents/OPL/FullpageLoading/FullPageLoading';

export const GoalLoading = () => {
  return <FullPageLoading text="Loading..." size="medium" />;
};
